var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFiRrPencil = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "fi-rr-pencil_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.427.574a1.813 1.813 0 0 0-2.562 0L.733 8.706A2.48 2.48 0 0 0 0 10.474V11.5a.5.5 0 0 0 .5.5h1.027a2.48 2.48 0 0 0 1.767-.732l8.133-8.133a1.813 1.813 0 0 0 0-2.561m-8.84 9.987c-.282.28-.663.438-1.06.439H1v-.527a1.5 1.5 0 0 1 .44-1.06L7.61 3.241l1.15 1.15zm8.132-8.133L9.466 3.682l-1.15-1.148L9.57 1.281a.812.812 0 1 1 1.147 1.15z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "fi-rr-pencil_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12v12H0z"
  })))));
};
export { SvgFiRrPencil as ReactComponent };
export default __webpack_public_path__ + "9b4e663e79e6e9cdc34140b4b5ffc436.svg";